<template>
  <tr :key="value.id" @click="$emit('onDetails', value)">
    <td v-for="header in headers" :key="header.text">
      
      <v-tooltip v-if="header.key === 'Status'" location="bottom">
        <template #activator="{ props }">
          <v-chip :color="value.Status.color" v-bind="props" dark>
            {{ value.Status.name }}
          </v-chip>
        </template>
        <span>{{ value.Status.description }}</span>
      </v-tooltip>

      <v-tooltip
        v-else-if="header.key === 'Website' && value.Website"
        location="bottom"
      >
        <template #activator="{ props }">
          <a
            v-bind="props"
            :href="value.Website.url"
            target="_blank"
            @click.stop
          >
            
            {{ value.Website.url }}
          </a>
        </template>
        <span>Open</span>
      </v-tooltip>

      <span v-else-if="header.key === 'created_at'">
        {{ formatDates(value.created_at) }}
      </span>
      <span v-else>
        {{ value[header.key] }}
      </span>
    </td>
  </tr>
</template>


<script>
import moment from "moment";

export default {
  name: "InventoryItemTableItem",
  components: {},
  inheritAttrs: false,
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["onDetails"],
  data() {
    return {
      fullScreenPreview: false,
    };
  },
  methods: {
    formatDates(date) {
      return moment(date).format("MMMM Do");
    },
    getStatus(item) {
      return item && item.Status && item.Status.code
        ? {
            text: item.Status.code,
            color: item.Status.color,
          }
        : {
            text: "Unknown",
            color: "grey",
          };
    },
  },
};
</script>